// composables/useTenant.ts

export function useTenant() {
  const nuxtApp = useNuxtApp()

  // useState를 사용하여 서버와 클라이언트 간에 상태 공유
  const subdomainState = useState<string | undefined>('subdomain', () => {
    if (import.meta.server) {
      // 서버 쪽에서는 event context에서 가져옴
      const event = useRequestEvent()
      return event?.context?.subdomain
    } else {
      // 클라이언트 쪽에서는 payload에서 가져옴
      const fromPayload = nuxtApp.payload.subdomain

      // CSR에서 직접 접근 시
      if (import.meta.client && fromPayload === undefined) {
        const hostname = window.location.hostname

        // 여기서 서브도메인 감지 로직 (tenant.client.ts와 동일한 로직)
        // 메인 도메인 체크
        const mainDomain = ["localhost", "webeasy.co.kr", "www.webeasy.co.kr", "staging.webeasy.co.kr"]
        if (mainDomain.includes(hostname)) {
          return undefined
        }

        const stagingDomain = "staging.webeasy.co.kr"

        // 각 환경별 체크
        if (hostname.endsWith(`.${stagingDomain}`)) {
          return hostname.replace(`.${stagingDomain}`, "")
        } else if (hostname.endsWith(`.webeasy.co.kr`)) {
          return hostname.replace(`.webeasy.co.kr`, "")
        } else if (hostname.endsWith(`.localhost`)) {
          return hostname.replace(`.localhost`, "")
        }
      }

      return fromPayload
    }
  })

  return {
    subdomain: subdomainState,
    isSubdomainSite: computed(() => !!subdomainState.value),
    tenantName: computed(() => subdomainState.value || 'main')
  }
}
